module.exports = __webpack_public_path__ + "img/bag-2.048042d4.jpg";